import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import simple_20rt from "./components/simple-20rt";
import simple_08rt from "./components/simple-08rt";
import simple_nart from "./components/simple-nart";

import optimisation_1_20rt from "./components/optimisation-1-20rt";
import optimisation_1_08rt from "./components/optimisation-1-08rt";
import optimisation_1_nart from "./components/optimisation-1-nart";

import optimisation_2_20rt from "./components/optimisation-2-20rt";
import optimisation_2_08rt from "./components/optimisation-2-08rt";
import optimisation_2_nart from "./components/optimisation-2-nart";

import optimisation_3_20rt from "./components/optimisation-3-20rt";
import optimisation_3_08rt from "./components/optimisation-3-08rt";
import optimisation_3_nart from "./components/optimisation-3-nart";

const principle: Slide = {
  description:
    "Starting from a simple shoebox, modify the room shape and/or the reverberation time, and listen to music played in it to hear the difference in terms of room presence and source presence. The source is reduced to a point source in the middle of the stage. Two types of music are available: unamplified symphonic music and amplified rock music.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          options: { label: "Room shape" },
          items: [
            { name: "Simple shoebox" },
            { name: "As 1 + optimisation in plan" },
            { name: "As 2 + optimisation in short section" },
            { name: "As 3 + optimisation in long section" },
          ],
        },
        {
          type: "dropdown",
          options: { label: "Reverberation time" },
          items: [
            { name: "RT = 2.0 s - No curtains" },
            { name: "RT = 0.8 s - Full curtains" },
            { name: "RT = n.a. - No room" },
          ],
        },
      ],
      extraContent: [
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
      ],
      components: [
        [simple_20rt, simple_08rt, simple_nart],
        [optimisation_1_20rt, optimisation_1_08rt, optimisation_1_nart],
        [optimisation_2_20rt, optimisation_2_08rt, optimisation_2_nart],
        [optimisation_3_20rt, optimisation_3_08rt, optimisation_3_nart],
      ],
      fullWidthControls: true,
    },
  },
};

export default principle;
